/**
 * Maps an API error detail (or any message) to ErrorAlert state.
 * When the message mentions "contact support", enables the customer support link + modal.
 */
export const toErrorAlertState = (message) => {
    const text = typeof message === 'string' ? message.trim() : '';
    if (!text) {
        return { errorFound: true, errorMessage: text };
    }
    if (/contact support/i.test(text)) {
        return {
            errorFound: true,
            errorMessage: text.replace(
                /contact support/i,
                'contact {customerSupport}',
            ),
            errorType: 'interactive',
        };
    }
    return { errorFound: true, errorMessage: text };
};

const errorMessages = {
    processing: {
        message: 'An error occurred while processing your request.',
    },
    generic: {
        message: 'We encountered an issue. You may try to sign in again, or if this error persists, please contact your administrator.',
    },
    resendCode: {
        message: 'An error occurred while resending your code. Please try again.',
    },
    invalidLogin: {
        message: 'The password you have entered is invalid.',
    },
    expiredPassword: {
        message: 'Your password has expired.',
    },
    forceResetPassword: {
        message: 'We are implementing a password reset policy as part of our continuous improvements that ensure data security.',
    },
    expiredVerificationLinkError: {
        message: 'Your verification link has expired or been previously used to reset your password.',
    },
    incorrectPassword: {
        message: 'Incorrect password. Please check your current password and try again.',
    },
    configError: {
        message: 'Yikes! Something went wrong. Please contact{customerSupport}for help.',
        type: 'interactive',
    },
    accountLocked: {
        message: 'Account locked due to multiple attempts. Try again in a few minutes.',
    },
    noActiveSession: {
        message: 'You have been logged out due to inactivity.',
    },
    emailExists: {
        message: 'An hStream ID with this email already exists.',
    },
    multipleProvisioned: {
        message: "There was a problem associated with this email. Please contact Support.",
    },
    invalidCode: {
        message: "Invalid verification code provided, please try again.",
    },
    phoneOnAnotherAccountLinking: {
        message:
            'This mobile number is already associated with another hStream ID. Please contact{customerSupport}for help.',
        type: 'interactive',
    },
};

export default errorMessages;
